/**
 * Sprint 98 — Qué encontró el mapa, y qué no.
 *
 * Vive fuera de `MapaPicker` a propósito: ese archivo importa Leaflet, que necesita un `window` al
 * cargarse. Una regla de negocio que se puede comprobar con dos cadenas no tiene por qué arrastrar
 * un motor de mapas para poder probarse.
 */

/**
 * El número de casa que el operador escribió en la búsqueda.
 *
 * Se toma el **primer** número de 1 a 5 dígitos: el código postal y el resto van después de la
 * calle, así que el primero de la cadena es, casi siempre, el número de la puerta.
 */
export function numeroDeCasa(busqueda: string): string | undefined {
  return busqueda.match(/\b(\d{1,5})\b/)?.[1];
}

/**
 * ¿El mapa devolvió la calle en vez de la casa?
 *
 * Reporte del negocio: se buscó *"Calle Júpiter 206, Fraccionamiento Galaxia"* y el mapa ofreció
 * *"Calle Jupiter, Fraccionamiento Galaxia, Villahermosa, Centro, Tabasco, 86035, México"* — la
 * calle entera, con el pin en el centro de la ciudad. Sin nada que lo advirtiera, esa dirección se
 * confirmaba y el repartidor salía a buscar una casa que el punto no señalaba.
 *
 * OpenStreetMap no tiene todos los números de Villahermosa y no es algo que se arregle desde aquí.
 * Lo que sí se puede es **no callarlo** y pedir el punto exacto, que es lo que el repartidor
 * necesita de todos modos.
 */
export function faltaElNumeroEnElResultado(busqueda: string, resultado: string): boolean {
  const numero = numeroDeCasa(busqueda);
  if (!numero || !resultado.trim()) return false;
  // Se compara contra los números del resultado, no contra el texto entero: si el "206" apareciera
  // dentro de un código postal ("20600") no sería el número de la casa.
  const numerosDelResultado: string[] = resultado.match(/\b\d{1,5}\b/g) ?? [];
  return !numerosDelResultado.includes(numero);
}
